import _ from 'lodash';
import block from 'bem-cn-lite';
import React, {useState, useCallback} from 'react';
import {Foldable} from '@yandex-data-ui/page-constructor';

import {NavigationGroupMobile, NavigationItem} from 'units/navigation/models';
import SimpleNavigationItem from 'units/navigation/components/SimpleNavigationItem/SimpleNavigationItem';
import ToggleArrow from 'components/ToggleArrow/ToggleArrow';

import './SidebarNavigationGroup.scss';

const b = block('sidebar-navigation-group');

export interface SidebarNavigationGroupProps {
    group: NavigationGroupMobile;
    className?: string;
}
const pickItemProps = (item: NavigationItem) => _.pick(item, ['url', 'title']);

const SidebarNavigationGroup: React.FunctionComponent<SidebarNavigationGroupProps> = ({
    group,
    className,
}) => {
    const [isOpened, setIsOpened] = useState<boolean>(false);
    const toggleOpen = useCallback(() => {
        setIsOpened(!isOpened);
    }, [isOpened]);
    const renderItems = (items: NavigationItem[]) =>
        items.map((item) => (
            <SimpleNavigationItem key={item.title} className={b('item')} {...pickItemProps(item)} />
        ));

    return (
        <div className={b(null, className)}>
            <div className={b('title', {opened: isOpened})} onClick={toggleOpen}>
                {group.title}
                <ToggleArrow
                    size={14}
                    type="vertical"
                    open={isOpened}
                    iconType="navigation"
                    className={b('arrow')}
                />
            </div>
            <Foldable isOpened={isOpened}>
                <div className={b('items')}>
                    {renderItems(group.items)}
                    {group.footer && <div className={b('footer')}>{renderItems(group.footer)}</div>}
                </div>
            </Foldable>
        </div>
    );
};

export default SidebarNavigationGroup;
